/**
 * Created by lihanying on 2017/7/1.
 */
import React from 'react'
import { CheckOutlined, CloseOutlined, UploadOutlined } from '@ant-design/icons'
import {
  Input,
  Select,
  Switch,
  message,
  Button,
  Checkbox,
  Row,
  Col,
  Spin,
} from 'antd'
import { IMAGE_DOMAIN } from '../../../config'
import { validateImageFile } from '../../../util'
const Option = Select.Option

export default class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
    }
  }

  onUpload = (e) => {
    let file = e.target.files[0]
    if (!validateImageFile(file)) {
      e.target.value = ''
      return
    }
    this.setState({ loading: true })
    let token = this.props.qiniuToken.token
    let form = new FormData()
    form.append('token', token)
    form.append('file', file)
    if (token != '') {
      this.props.fetchQiniu(form).then((res) => {
        this.setState({ loading: false })
      })
    } else {
      this.setState({ loading: false })
      message.error('上传失败')
    }
  }

  onChange1 = (value) => {
    let off_shelve = 0
    if (value) {
      off_shelve = 1
    }
    sessionStorage.setItem('off_shelve', off_shelve)
  }

  render() {
    const { record, commodityType, imageUrl, commodityTotal, total_c } =
      this.props
    let imgUrl
    if (imageUrl.url) {
      imgUrl = IMAGE_DOMAIN + imageUrl.url || ''
    } else {
      imgUrl = IMAGE_DOMAIN + record.commodity_pic_url || ''
    }
    let total_id = []
    if (total_c === 0) {
      commodityTotal.firmList &&
        commodityTotal.firmList.map((item) => {
          if (+item.access === 1) {
            total_id.push(item.id)
          }
        })
    } else {
      total_id = [].concat(total_id, total_c)
    }

    return (
      <div className="commodity">
        <div className="commodity-left">
          <div className="diamond-item">
            <span className="diamond-span">商品名称:</span>
            <Input
              defaultValue={record.commodity_name}
              style={{ width: '80%', marginLeft: '1rem' }}
              placeholder="请输入商品名称"
              onChange={(e) =>
                sessionStorage.setItem('commodity_name', e.target.value)
              }
            />
          </div>
          <div className="diamond-item">
            <span className="diamond-span">销售价格:</span>
            <Input
              defaultValue={record.commodity_price}
              style={{ width: '80%', marginLeft: '1rem' }}
              placeholder="请输入商品价格"
              onChange={(e) =>
                sessionStorage.setItem('commodity_price', e.target.value)
              }
            />
          </div>
          <div className="commodity-item">
            <span className="diamond-span">钻石抵扣:</span>
            <Input
              defaultValue={record.re_price}
              addonAfter="元"
              style={{ width: '36.5%', marginLeft: '1rem' }}
              placeholder="请输入商品销售价格"
              onChange={(e) =>
                sessionStorage.setItem('re_price', e.target.value)
              }
            />
            <span className="commodity-diamond">+</span>
            <Input
              defaultValue={record.al_price}
              addonAfter="钻"
              style={{ width: '37%' }}
              placeholder="请输入钻石数量(只接受整数)"
              onChange={(e) =>
                sessionStorage.setItem('al_price', e.target.value)
              }
            />
          </div>
          <div className="diamond-item">
            <span className="diamond-span">单位:</span>
            <Input
              defaultValue={record.unit}
              style={{ width: '80%', marginLeft: '2.4rem' }}
              placeholder="商品的单位"
              onChange={(e) => sessionStorage.setItem('unit', e.target.value)}
            />
          </div>
          <div className="diamond-item">
            <span className="diamond-span">菜单排序:</span>
            <Input
              defaultValue={record.ordernum}
              style={{ width: '80%', marginLeft: '1rem' }}
              placeholder="数字越小越靠前,可不填"
              onChange={(e) =>
                sessionStorage.setItem('order_num', e.target.value)
              }
            />
          </div>
          <div className="diamond-item">
            <span className="diamond-span">商品分类:</span>
            <Select
              defaultValue={record.type_id}
              style={{ width: '80%', marginLeft: '1rem' }}
              onChange={(value) => sessionStorage.setItem('type_id', value)}
            >
              {commodityType &&
                commodityType.map((item, idx) => {
                  return (
                    <Option value={item.id} key={idx}>
                      {item.name}
                    </Option>
                  )
                })}
            </Select>
          </div>
          <div style={{ marginBottom: '2rem' }}>
            <div>商品销售区域:</div>
            <Checkbox.Group
              value={total_id}
              style={{ width: '100%' }}
              onChange={(value) => this.props.handleEditCheckbox(value)}
            >
              <Row>
                {commodityTotal.firmList &&
                  commodityTotal.firmList.map((item, idx) => {
                    return (
                      <Col span={6} key={idx}>
                        <Checkbox value={item.id}>{item.type_name}</Checkbox>
                      </Col>
                    )
                  })}
              </Row>
            </Checkbox.Group>
          </div>
          <div>
            <span>是否为加工制品:</span>
            <div className="commodity-icon">
              {record.non_standard == 1 ? (
                <CheckOutlined style={{ fontSize: '18px', color: '#108EE9' }} />
              ) : (
                <CloseOutlined style={{ fontSize: '18px', color: 'red' }} />
              )}
            </div>
          </div>
          <p style={{ marginBottom: '2rem' }}>
            (注: 加工制品如 快餐, 调饮等商品, 该类商品不设库存, 日常如需入库)
          </p>
          <div className="diamond-item">
            <span>下架:</span>
            <Switch
              defaultChecked={record.off_shelve == 1 ? true : false}
              onChange={this.onChange1}
              style={{ marginLeft: '2.5rem' }}
            />
          </div>
        </div>

        <div className="commodity-right">
          <Button type="primary" style={{ marginBottom: '1rem' }}>
            <UploadOutlined />
            <input
              type="file"
              className="upload-input"
              onChange={(e) => this.onUpload(e)}
            />
            上传图片
          </Button>
          {this.state.loading ? (
            <Spin
              tip="正在加载..."
              className="level-loading"
              style={{ textAlign: 'center' }}
            />
          ) : (
            <div>
              {imgUrl && (
                <div className="commodity-image">
                  <div>
                    <img
                      src={imgUrl}
                      alt=""
                      style={{ width: '100px', height: '100px' }}
                    />
                    <CloseOutlined
                      className="commodity-icon"
                      onClick={() => this.props.getImageUrl({})}
                    />
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubCommodity/component/commodityInfo.js